import cloneDeep from 'lodash/cloneDeep';
import * as types from '../../actions/actionTypes';
import initialState from '../initialState';
import { _createTargetUniqueID, _validateDuplicateTarget } from '../../util/deUtils';

export const deBuildReducer = (state = initialState.deBuild, action) => {
  switch (action.type) {
    case types.ADD_DE_AUTOCODE_TARGETS: {
      const expression = action.expression;
      let id;
      const targetData = expression.map((exp, index) => {
        let weightedVal = action.payload[index];
        if(weightedVal === null) {
          weightedVal = {};
          weightedVal.pct = 0;
          weightedVal.weighted = 0;
          weightedVal.intab = 0;
          weightedVal.modeled = false;
        }
        if(state.tempTarget 
          && state.tempTarget !== null
          && Object.keys(state.tempTarget).length > 0){
            id = state.tempTarget.id;
          }
        return {
          id,
          pct: weightedVal.pct? weightedVal.pct * 100 : weightedVal.pct,
          weighted: Math.round(weightedVal.weighted),
          sample: Math.round(weightedVal.intab),
          ex: exp,
          pn: action.study.pn,
          wt: action.selectedWeightType.wt,
          div: action.selectedWeightType.dv,
          // eslint-disable-next-line radix
          ss: parseInt(action.study.st),
          sn: `${action.study.sd} ${action.selectedWeightType.wn}`,
          isActive: false,
          isDisabled: false,
          tn: action.tn,
          ui: action.uniqueId,
          originalTitle: action.autocodenode.labelOverride || '',
          isLabelUpdated: action.autocodenode.useLabelOverride || false,
          isFailed: false,
          isDuplicate: false,
          actualLabel: action.tn,
          ct: new Date(),
          isDuplicateTarget: false,
          dataSmartSearch: {
            autocodenode: action.autocodenode,
          }
        };
      });
      return {
        ...state,
        tempTarget: null,
        editTarget: null,
        deBuildTargets: [...targetData, ...state.deBuildTargets],
      };
    }

    case types.SAVE_DE_AUTOCODE_TARGET: {
      const response = action.payload;
      const failedTargetList = response.filter(item => !item.ut && !item.uti && item.me);
      const failedTargetArr = [];
      failedTargetList.forEach(items => {
         const arr = action.deBuildTargets.filter(item => item.ex === items.ex && item.ui === items.ui);
         if(arr.length > 0) {
           arr[0].isFailed = true;
          failedTargetArr.push(arr[0]);
         }
      });
      return {
        ...state,
        tempTarget: null,
        editTarget: null,
        deBuildTargets: [...action.notSentToSaveTargets, ...failedTargetArr],
      };
    }

    case types.REMOVE_DE_AUTOCODE_TARGETS: {
      return {
        ...state,
        deBuildTargets: [],
      }
    }
    
    case types.REMOVE_DE_AUTOCODE_TARGET_ROW: {
      return {
        ...state,
        deBuildTargets: action.deBuildTargets,
      }
    }

    case types.RESET_SAVED_COUNT: {
      return {
        ...state,
        savedListCount: 0,
        failedListCount: 0,
      }
    }

    case types.DE_SET_SELECTED_LABEL_AC: {
      const deBuildTargets = cloneDeep(state.deBuildTargets);
      const newTargets = deBuildTargets.map(item => {
        let uniqueId = item.ui;
        uniqueId = uniqueId.split('_');
        item.ui = _createTargetUniqueID(item.dataSmartSearch.autocodenode, action.labelConfig,
          item.pn, uniqueId[uniqueId.length - 1]);
        return item;
      });
      return {
        ...state,
        partsToShow: action.labelConfig,
        deBuildTargets: newTargets,
      }
    }

    case types.DE_BUILD_UPDATE_EXPRESSION_NAME: {
      const targets = cloneDeep(state.deBuildTargets);
      if( action.isCancel ){
        const duplicateList = targets.filter(item =>
          item.ui.toLowerCase() === targets[action.index].ui.toLowerCase() 
          && !item.isFailed);
        if( duplicateList.length === 2){
          const duplicateId = duplicateList[0].ui
          targets.map(item => {
            if(item.ui === duplicateId){
              item.isDuplicate = false;
            }
            return item;
          });
        }
      }
      targets[action.index].originalTitle = action.name
      targets[action.index].tn = action.name
      targets[action.index].isLabelUpdated = true
      targets[action.index].isFailed = action.isFailed
      targets[action.index].isDuplicate = action.isDuplicate
      targets[action.index].isDuplicateTarget = false
      if( action.isCancel && _validateDuplicateTarget(targets,targets[action.index]).length > 1){
        targets[action.index].isDuplicate = true
      }
      if( !targets[action.index].isFailed && !targets[action.index].isDuplicate){
        targets[action.index].actualLabel = targets[action.index].originalTitle
      }
      if (targets[action.index].dataSmartSearch && targets[action.index].dataSmartSearch.autocodenode) {
        targets[action.index].dataSmartSearch.autocodenode.useLabelOverride = true;
        targets[action.index].dataSmartSearch.autocodenode.labelOverride = action.name;
      }

      let uniqueId = targets[action.index].ui;
      uniqueId = uniqueId.split('_');
      targets[action.index].ui = _createTargetUniqueID(
        targets[action.index].dataSmartSearch.autocodenode, 
        state.partsToShow,
        targets[action.index].pn, 
        uniqueId[uniqueId.length - 1]
      );
      return {
        ...state,
        deBuildTargets: [...targets],
      };
    }

    case types.DE_BUILD_UPDATE_UNSAVED_CHANGES: {
      return {
        ...state,
        unsavedSelectionBox: action.flag
      }
    }

    case types.DE_BUILD_UPDATE_ERROR_SELECTION_BOX: {
      return {
        ...state,
        errorSelectionBox: action.payload
      }
    }

    case types.SET_DE_AUTOCODE_TEMP_TARGET_EDIT: {
      return {
        ...state,
        tempTarget: action.target,
        successDeBuildTargets: []
      }
    }

    case types.SET_ADD_TARGET_API_FLAG: {
      return {
        ...state,
        addTargetAPIFlag: action.flag,
      }
    }

    case types.SET_DE_BUILD_EDIT_TARGET: {
      return {
        ...state,
        editTarget: action.target
      }
    }

    case types.DE_BUILD_SET_IS_SAVE_TARGET_CLICKED: {
      return {
        ...state,
        isSaveTargetClicked: action.isClicked
      }
    }

    case types.DE_BUILD_SET_IS_EDIT_TARGET: {
      return {
        ...state,
        isEditTarget: action.isEditTarget
      }
    }

    case types.DE_BUILD_DUPLICATE_TARGET: {
      const target = cloneDeep(action.target);
      target.isLabelUpdated = true
      target.isFailed = action.isFailed
      target.isDuplicate = action.isDuplicate
      target.id = undefined
      target.ct = new Date()
      target.isDuplicateTarget = true
      if( !target.isFailed && !target.isDuplicate){
        target.actualLabel = target.originalTitle
      }
      if (target.dataSmartSearch && target.dataSmartSearch.autocodenode) {
        target.dataSmartSearch.autocodenode.useLabelOverride = true;
        target.dataSmartSearch.autocodenode.labelOverride = target.originalTitle;
      }

      let uniqueId = target.ui;
      uniqueId = uniqueId.split('_');
      target.ui = _createTargetUniqueID(
        target.dataSmartSearch.autocodenode,
        state.partsToShow,
        target.pn,
        uniqueId[uniqueId.length - 1]
      );
      const duplicateTarget = [];
      duplicateTarget.push(target)
      return {
        ...state,
        deBuildTargets: [...duplicateTarget, ...state.deBuildTargets],
      };
    }

    default:
      return state;
  }
};
